<template>
  <div class="my-3" justify="center" align="center">
    <v-icon>{{icon}}</v-icon>
    <v-spacer />
    <span >{{noDataText}}</span>
  </div>
</template>
<script>
export default {
  name: "NoData",
  props: {
    text: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "mdi-database"
    }
  },
  computed: {
    noDataText() {
      return this.text || this.$t("NoData");
    }
  }
};
</script>